import axios from "axios";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import theme from "../styles/theme";
import CompetencyModal from "./CompetencyModal";
import { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import { UserContext } from "../context/UserContext";
import { UniversityContext } from "../context/UniversityContext";

const Header = styled.h4`
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;

const FlexBox = styled("div")`
  display: flex;
  margin-bottom: 5px;
  align-items: center;
`;
const CustomFlex = styled(FlexBox)`
  padding: 0px 0px 20px 0px;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;

const Card = styled("div")`
  background: #1e2131;
  border-radius: 5px;
  width: fit-content;
  padding: 20px;
  margin: 10px 0;
`;

type CheckCanvasCourseModalProps = {
  isOpen?: boolean;
  data:any;
  semesterName: string;
  setOpen: (x: boolean) => void;
};

const CheckCanvasCourseModal = ({
  isOpen,
  setOpen,
  data,
  semesterName,
}: CheckCanvasCourseModalProps): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(false);
  const [report, setReport] = useState<string>("");
  const currentUser = useContext(UserContext).user;
  const universityContext = useContext(UniversityContext);

  useEffect(() => {
    if (isOpen && data?.competency_code && semesterName) {
      fetchCanvasReport(data.competency_code, semesterName);
    }
    // eslint-disable-next-line
  }, [isOpen, data, semesterName, universityContext.selectedProgram]);

  const fetchCanvasReport = (code: string, semester: string) => {
    setLoading(true);
    axios
      .get(`/canvas/check?competency_code=${encodeURIComponent(code)}&semester_name=${encodeURIComponent(semester)}&program_name=${data?.program_name}&university_code=CMKL`)
      .then((res) => {
        setReport(res.data?.report || "No report available.");
        setLoading(false);
      })
      .catch(() => {
        setReport("Failed to fetch Canvas course report.");
        setLoading(false);
      });
  };

  return (
    <CompetencyModal
      customStyle={{
        overlay: {
          zIndex: "1005",
        },
        content: {
          inset: `0px 0px 0px ${theme.sidebarWidth}`,
          maxWidth: "100%",
          background: "#0B0C1F",
          overflowY: "auto",
        },
      }}
      isOpen={isOpen || false}
      setOpen={setOpen}
    >
      <CustomFlex>
        <ClickableIcon
          size={3.125}
          fixedWidth={false}
          name="times"
          onClick={() => setOpen(false)}
        />
        <FlexGrow>
          <Header>
            Canvas Course Checker for {data?.competency_code}
          </Header>
        </FlexGrow>
      </CustomFlex>

      <div style={{ margin: "20px 0" }}>
        <FlexBox>
          <div style={{ minWidth: 300 }}>Competency Title</div>
          <div>: {data.title}</div>
        </FlexBox>
        <FlexBox>
          <div style={{ minWidth: 300 }}>Semester</div>
          <div>: {semesterName}</div>
        </FlexBox>
        <FlexBox>
          <div style={{ minWidth: 300 }}>Instructor Name</div>
          <div>: {currentUser.title + " " + currentUser.name}</div>
        </FlexBox>
      </div>

      <div style={{ margin: "20px 0" }}>
        <span style={{ fontWeight: "bold" }}>Canvas Course Report</span>
        <Card style={{ maxHeight: "100%", overflowY: "auto", width: "auto" }}>
          {loading ? (
            <div style={{ color: "yellow" }}>Loading report...</div>
          ) : (
            <pre style={{ whiteSpace: "pre-wrap", color: "#fff", margin: 0 }}>
              {report}
            </pre>
          )}
        </Card>
      </div>
    </CompetencyModal>
  );
};

export default CheckCanvasCourseModal;